import { AxiosResponse } from 'axios';
import { UnknownNetworkError } from '../../application/commonModels/apiResponse';
import {
  AppleRegisterError,
  AppleRegisterSuccess
} from '../../application/usecases/appleInteractor';
import { AppleAuthCode } from '../../domain/apple';
import { WA_SERVICE } from '../../domain/waService';
import { PromiseEither } from '../../utils/either';
import { Option } from '../../utils/option';
import { convertWaServiceToTrackerRegisteredVia } from '../../utils/registeredVia';
import ApiClient from './client';
import {
  EmailNullableSecureUserData,
  getSecureUserErrorContent,
  SecureUserErrorData
} from './models';

const register = async (
  authCode: AppleAuthCode,
  waService: WA_SERVICE
): PromiseEither<AppleRegisterError, AppleRegisterSuccess> => {
  const res = await ApiClient.instance.post<EmailNullableSecureUserData>(
    '/auth/apple/registrations',
    {
      secure_user: {
        secure_apple_account: {
          auth_code: authCode,
          device: 'web'
        }
      },
      registered_via: convertWaServiceToTrackerRegisteredVia(waService)
    },
    'wapi'
  );
  return res
    .leftMap<AppleRegisterError>((e) =>
      Option<AxiosResponse<SecureUserErrorData>>(e.response)
        .flatMap(({ data }) =>
          getSecureUserErrorContent(Option(data)).map(
            (error) => new AppleRegisterError(error)
          )
        )
        .getOrElse<AppleRegisterError>(() => new UnknownNetworkError())
    )
    .map<AppleRegisterSuccess>(({ data, status }) => {
      const { email } = data.secure_user;
      return {
        accessToken: data.secure_user.access_token,
        refreshToken: data.secure_user.refresh_token,
        userId: data.user.id,
        email,
        sessionStatus: status === 201 ? 'signUp' : 'signIn'
      };
    });
};

export default {
  register
};
